import PropTypes from '~/lib/propTypes'
import {
  color,
  DialogAdornment,
  DialogBody,
  DialogHeader,
  DialogWindow,
  useDialog,
} from '@ticketswap/solar'
import { CloseAlt } from '@ticketswap/solar/icons'
import styled from '@emotion/styled'

const EmbedContainer = styled.div`
  position: relative;
  padding-block-end: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;

  iframe,
  object,
  embed {
    position: absolute;
    inset-block-start: 0;
    inset-inline-start: 0;
    width: 100%;
    height: 100%;
  }
`

const CloseDialogButton = styled.button`
  color: ${color.foreground};
`

const HowItWorksVideoDialog = ({ children, t }) => {
  const { show, hide, getWindowProps } = useDialog()

  return (
    <>
      {children({ show })}
      <DialogWindow {...getWindowProps()}>
        <DialogHeader>
          {t('common:footer.howItWorks.title')}
          <DialogAdornment right>
            <CloseDialogButton onClick={hide}>
              <CloseAlt size={24} />
            </CloseDialogButton>
          </DialogAdornment>
        </DialogHeader>
        <DialogBody>
          <EmbedContainer>
            <iframe
              title={t('common:footer.howItWorks.title')}
              src="https://www.youtube.com/embed/6YISCKlqCS0"
              frameBorder="0"
              allowFullScreen
            />
          </EmbedContainer>
        </DialogBody>
      </DialogWindow>
    </>
  )
}

HowItWorksVideoDialog.propTypes = {
  t: PropTypes.func.isRequired,
}

export default HowItWorksVideoDialog
